import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Map, List } from 'immutable';

import * as adminActions from 'modules/admin';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm } from 'redux-form';
import { injectIntl, defineMessages } from 'react-intl';

import { ConfigTemplate, AdminPageTitle, AdminPageTemplate } from 'components';
import { CtSmtpTest, CtConfigInitial } from 'containers';

class CtAdminSmtpConf extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loaded: 0
      //initValue: {}
    };
  }

  componentDidMount() {
    this.getSystemConfig();
  }

  getSystemConfig = async () => {
    const { AdminActions, paramInfo } = this.props;

    try {
      await AdminActions.getSystemConfigSmtp();
    } catch (e) {
      console.log(e);
    }

    this.setState({ loaded: 1 });
  };

  render() {
    if (this.state.loaded === 0) {
      return null;
    }
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { isAuth, configClassOrder, configParamOrder, mailSmtpTested } = this.props;

    let classOrder = [];
    if (configClassOrder && List.isList(configClassOrder)) {
      classOrder = configClassOrder.toJS();
    }

    let paramOrder = {};
    if (configParamOrder && Map.isMap(configParamOrder)) {
      paramOrder = configParamOrder.toJS();
    }

    let smtpTestInfo = {};
    if (mailSmtpTested && Map.isMap(mailSmtpTested)) {
      smtpTestInfo = mailSmtpTested.toJS();
    }

    return (
      <AdminPageTemplate>
        <AdminPageTitle small title={'SMTP'}>
          <CtConfigInitial category="smtp" />
        </AdminPageTitle>
        <ConfigTemplate category="configSmtp" order={classOrder} lists={paramOrder} isAuth={isAuth} />
        <CtSmtpTest mailSmtpTested={smtpTestInfo} />
      </AdminPageTemplate>
    );
  }
}

CtAdminSmtpConf.propTypes = {};

const mapStateToProps = state => {
  return {
    mailSmtpTested: state.admin.getIn(['configSmtp', 'parameter', 'mailSmtpTested']),
    configClassOrder: state.admin.getIn(['configSmtp', 'classOrder']),
    configParamOrder: state.admin.getIn(['configSmtp', 'class']),
    isAuth: state.user.get('isAuth')
  };
};

const mapDispatchToProps = dispatch => ({
  AdminActions: bindActionCreators(adminActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(CtAdminSmtpConf));



// WEBPACK FOOTER //
// ./src/script/containers/admin/config/CtAdminSmtpConf.js